export const aboutData = {
    title: "Who I am",
    description1: "My name's Ananda Gouda. I'm a B.Sc graduated Full stack web developer  based in India.",
    description2: "I have proficiency in MERN stack but am open to exploring other technologies also. As a tech enthusiast, I always thrive to work on end to end products which develop sustainable and scalable, social and technical system to create impact.",
    image: 1
}